import React from 'react';
import { ModalPanelProps } from 'app/components/panels/DashboardModal';
import {
    ExtendedMonitoredTv,
    MilitaryZoneDto,
    MonitoredEvent,
    MonitoredMeasure,
    MonitoredRegulationOutlook,
    NiaMeasureImpact,
    PolygonMeteoForecast,
    TrafficVolumeMeteoForecast,
    TvMeteoAlert,
} from 'app/model/SOL49';
import { TVLoadProps } from 'app/components/dashboard/network/flows/TVLoad';
import { SortUtils } from 'app/common/util/SortUtils';
import MeasureUtils from 'app/common/util/MeasureUtils';
import { MapTVContextMenu } from 'app/components/dashboard/network/flows/menu/MapTVContextMenu';
import Utils from 'app/common/util/Utils';
import { FlightId, HotspotDto, TimePeriod } from 'app/model/CORE';
import { MapMeasureContextMenu } from 'app/components/dashboard/network/flows/menu/MapMeasureContextMenu';
import MapTvConvectionContextMenu from 'app/components/dashboard/network/flows/menu/MapTvConvectionContextMenu';
import memoizeOne from 'memoize-one';
import { MapMilitaryZoneContextMenu } from 'app/components/dashboard/network/flows/menu/MapMilitaryZoneContextMenu';
import { MapPolygonConvectionContextMenu } from 'app/components/dashboard/network/flows/menu/MapPolygonConvectionContextMenu';
import { MapLayerUtils, SolutionTvImpact } from 'app/components/dashboard/network/map/Map';
import MapTVImpactContextMenu from 'app/components/dashboard/network/flows/menu/MapTVImpactContextMenu';
import { MapMeasureImpactContextMenu } from 'app/components/dashboard/network/flows/menu/MapMeasureImpactContextMenu';
import { MonitoredEventUtils } from 'app/common/util/MonitoredEventUtils';
import { MeasureLoadProps } from 'app/components/dashboard/network/flows/MeasureLoad';
import { MapHotspotContextMenu } from 'app/components/dashboard/network/flows/menu/MapHotspotContextMenu';
import { HotspotLoadProps } from 'app/components/dashboard/network/flows/HotspotLoad';
import { Menu } from 'antd';
import { RegulationOutlookPanel } from 'app/components/panels/measure/RegulationOutlookPanel';
import { ShowModalEvent } from 'app/common/eventbus/Events';
import { RegulationOutlookLoad } from 'app/components/dashboard/network/flows/RegulationOutlookLoad';
import AppContext from 'app/common/context/AppContext';

export interface MapContextMenuProps extends ModalPanelProps {
    tvs: Array<ExtendedMonitoredTv>;
    workspaceTvs: Array<ExtendedMonitoredTv>;
    measures: Array<MonitoredMeasure>;
    hotspots: { [p: string]: HotspotDto[] };
    regOutlooks: Array<MonitoredRegulationOutlook>;
    workspaceMeasures: Array<MonitoredMeasure>;
    monitoredMeasures: Array<MonitoredMeasure>;
    selectedFlightsOccupancyPeriods: { [key: string]: Map<FlightId, TimePeriod> };
    tvSetMap: { [key: string]: string };
    currentTime: Date;
    selectedTvs: Array<ExtendedMonitoredTv>;
    proposalMeasureIds: Array<string>;
    monitoredTvList: Array<ExtendedMonitoredTv>;
    tvConvections: Array<TrafficVolumeMeteoForecast>;
    polygonConvections: Array<PolygonMeteoForecast>;
    convectionTvs: Array<ExtendedMonitoredTv>;
    militaryZones: Array<MilitaryZoneDto>;
    impactedTvs: Array<SolutionTvImpact>;
    impactedMeasures: Array<NiaMeasureImpact>;
    events: Array<MonitoredEvent>;
    meteoAlerts: { [tv: string]: Array<TvMeteoAlert> };
}

export interface ObjectTypeContextMenu {
    group: boolean;
}

export class MapContextMenu extends React.PureComponent<MapContextMenuProps> {
    static MAP_CONTEXT_MENU_SINGLE_WIDTH_EM = '35em';
    static MAP_CONTEXT_MENU_GROUP_WIDTH_EM = '17em';

    render() {
        if (
            this.props.tvs?.length > 0 ||
            this.props.measures?.length > 0 ||
            (this.props.hotspots && Object.keys(this.props.hotspots)?.length > 0) ||
            this.props.tvConvections?.length > 0 ||
            this.props.militaryZones?.length > 0 ||
            this.props.polygonConvections?.length > 0 ||
            this.props.impactedTvs?.length > 0 ||
            this.props.impactedMeasures?.length > 0 ||
            this.props.regOutlooks?.length > 0
        ) {
            const onlyOneKindOfMenu = MapContextMenu.hasOnlyOneKindOfMenu(this.props);
            return (
                <div style={{ minWidth: '15em' }} onContextMenu={this.handleContextMenu}>
                    <div
                        className="detailed-subpanel-title"
                        style={{ height: '2.5em', width: '100%', textAlign: 'center', lineHeight: '2.5em' }}>
                        SELECTION
                    </div>
                    {this.props.tvs?.length > 0 &&
                        this.renderTvMapContextMenuOptions(this.props.tvs, this.props.workspaceTvs, !onlyOneKindOfMenu)}
                    {this.props.measures?.length > 0 &&
                        this.renderMeasuresMapContextMenuOptions(
                            this.props.measures,
                            this.props.workspaceMeasures,
                            !onlyOneKindOfMenu,
                        )}
                    {this.props.hotspots &&
                        Object.keys(this.props.hotspots).length > 0 &&
                        this.renderHotspotsMapContextMenuOptions(this.props.hotspots, !onlyOneKindOfMenu)}
                    {this.props.tvConvections?.length > 0 &&
                        this.renderTvConvectionsMapContextMenuOptions(
                            this.props.tvConvections,
                            this.props.convectionTvs,
                            !onlyOneKindOfMenu,
                        )}
                    {this.props.polygonConvections?.length > 0 &&
                        this.renderPolygonConvectionsMapContextMenuOptions(
                            this.props.polygonConvections,
                            this.props.convectionTvs,
                            !onlyOneKindOfMenu,
                        )}
                    {this.props.militaryZones?.length > 0 &&
                        this.renderMilitaryZonesContextMenuOptions(this.props.militaryZones, !onlyOneKindOfMenu)}
                    {this.props.impactedTvs?.length > 0 &&
                        this.renderSolutionTvImpactMapContextMenuOptions(
                            this.props.impactedTvs,
                            this.props.workspaceTvs,
                            !onlyOneKindOfMenu,
                        )}
                    {this.props.impactedMeasures?.length > 0 &&
                        this.renderSolutionMeasureImpactMapContextMenuOptions(
                            this.props.impactedMeasures,
                            this.props.workspaceMeasures,
                            !onlyOneKindOfMenu,
                        )}
                    {this.props.regOutlooks?.length > 0 &&
                        this.renderRegOutlookMapContextMenuOptions(this.props.regOutlooks, !onlyOneKindOfMenu)}
                </div>
            );
        }
    }

    handleContextMenu = event => {
        event.preventDefault();
    };
    public static hasOnlyOneKindOfMenu(props: MapContextMenuProps): boolean {
        return (
            MapContextMenu.itExists(props.tvs) +
                MapContextMenu.itExists(props.measures) +
                (Utils.isExists(props.hotspots) && Object.keys(props.hotspots).length > 0 ? 1 : 0) +
                MapContextMenu.itExists(props.tvConvections) +
                MapContextMenu.itExists(props.militaryZones) +
                MapContextMenu.itExists(props.polygonConvections) +
                MapContextMenu.itExists(props.impactedTvs) +
                MapContextMenu.itExists(props.impactedMeasures) +
                MapContextMenu.itExists(props.regOutlooks) ===
            1
        );
    }

    renderRegOutlookMapContextMenuOptions(monitoredRegOutlooks: MonitoredRegulationOutlook[], group: boolean) {
        let items;
        const subMenu = monitoredRegOutlooks?.map(mrg => ({
            label: (
                <RegulationOutlookLoad
                    monitoredRegulationOutlook={mrg}
                    currentTime={AppContext.getCurrentTime()}
                    hideMoreMenu={true}
                />
            ),
            key: mrg.regulationOutlook.aerodromeId,
            className: 'menuItemConvection',
            onClick: () =>
                ShowModalEvent.fire(
                    <RegulationOutlookPanel regOutlook={mrg.regulationOutlook} />,
                    RegulationOutlookPanel.REGULATION_OUTLOOK_PANEL_WIDTH_EM,
                ),
        }));
        if (group) {
            items = [
                {
                    label: (
                        <span className="detailed-subpanel-title">
                            Regulation outlook ({monitoredRegOutlooks.length})
                        </span>
                    ),
                    key: 'regOutlook',
                    children: subMenu,
                },
            ];
        } else {
            items = subMenu;
        }
        return <Menu items={items} />;
    }

    renderTvMapContextMenuOptions(
        tvs: Array<ExtendedMonitoredTv>,
        workspaceTvs: Array<ExtendedMonitoredTv>,
        group: boolean,
    ) {
        const output: Array<TVLoadProps> = this.getTvLoadProps(tvs);
        return (
            <MapTVContextMenu
                group={group}
                tvs={output}
                workspaceTvIds={workspaceTvs?.map(emt => emt.refLocation.id)}
                monitoredTvList={tvs}
                onClose={this.props.onClose}
            />
        );
    }

    renderMeasuresMapContextMenuOptions(measures: Array<MonitoredMeasure>, workspaceMeasures, group: boolean) {
        const output: MeasureLoadProps[] = measures
            ?.sort(SortUtils.MONITORED_MEASURE_ALPHABETICAL_SORTING)
            .map(monitoredMeasure => {
                const tvLocation = MeasureUtils.getTvLocation(monitoredMeasure.measure);
                const measureEvents = this.props.events?.filter(e => {
                    return (
                        (MonitoredEventUtils.isWeatherEvent(e) &&
                            e.refLocs?.some(refLoc => Utils.isShallowEquals(refLoc, tvLocation.refLocation))) ||
                        (MonitoredEventUtils.isNoteEvent(e) &&
                            e.measures?.includes(monitoredMeasure.measure.measureId.id))
                    );
                });
                return {
                    hideMeasureId: true,
                    hideSelectIcon: true,
                    hideMoreMenu: true,
                    key: monitoredMeasure.measure.measureId.id,
                    monitoredMeasure: monitoredMeasure,
                    currentTime: this.props.currentTime,
                    monitoredTv: this.props.monitoredTvList?.find(
                        monitoredTv =>
                            MeasureUtils.getTvLocation(monitoredMeasure.measure).id === monitoredTv.refLocation.id,
                    ),
                    selected: false,
                    hasOngoingProposal:
                        this.props.proposalMeasureIds &&
                        Utils.contains(this.props.proposalMeasureIds, monitoredMeasure.measure.measureId.id),
                    monitoredEvents: measureEvents,
                };
            });
        return (
            <MapMeasureContextMenu
                group={group}
                measures={output}
                onClose={this.props.onClose}
                workspaceMeasureIds={workspaceMeasures?.map(mm =>
                    MapLayerUtils.MONITORED_MEASURE_KEY_PROVIDER.getKey(mm),
                )}
            />
        );
    }

    renderHotspotsMapContextMenuOptions(hotspots: { [p: string]: HotspotDto[] }, group: boolean) {
        const sorted: { [p: string]: HotspotDto[] } = Object.keys(hotspots)
            .sort()
            .reduce((obj, key) => {
                obj[key] = hotspots[key];
                return obj;
            }, {});
        const output: HotspotLoadProps[] = Object.entries(sorted)?.map(([tv, hotspots]) => {
            const monitoredTv = this.props.monitoredTvList?.find(monitoredTv => tv === monitoredTv.refLocation.id);
            const monitoredEvents = this.props.events?.filter(e => this.eventHasTv(e, monitoredTv));
            const measures = this.props.measures?.filter(m => MeasureUtils.getTvLocation(m.measure).id === tv);
            return {
                tv: tv,
                hotspots: hotspots,
                monitoredTv: monitoredTv,
                monitoredEvents: monitoredEvents,
                measures: measures,
                selected: false,
                currentTime: this.props.currentTime,
            };
        });
        return <MapHotspotContextMenu group={group} hotspots={output} onClose={this.props.onClose} />;
    }

    private renderTvConvectionsMapContextMenuOptions(
        convections: TrafficVolumeMeteoForecast[],
        tvs: Array<ExtendedMonitoredTv>,
        group: boolean,
    ) {
        //converting in here to avoid passing to much props to the MapTvContextMenu
        const tvLoads: Array<TVLoadProps> = this.getTvLoadProps(tvs);
        return (
            <MapTvConvectionContextMenu
                group={group}
                convections={convections}
                tvLoads={tvLoads}
                onClose={this.props.onClose}
            />
        );
    }

    private renderPolygonConvectionsMapContextMenuOptions(
        convections: PolygonMeteoForecast[],
        tvs: ExtendedMonitoredTv[],
        group: boolean,
    ) {
        const tvLoads: Array<TVLoadProps> = this.getTvLoadProps(tvs);
        return (
            <MapPolygonConvectionContextMenu
                group={group}
                convections={convections}
                tvLoads={tvLoads}
                onClose={this.props.onClose}
            />
        );
    }

    private getTvLoadProps = memoizeOne((tvs: Array<ExtendedMonitoredTv>): Array<TVLoadProps> => {
        //converting in here to avoid passing to much props to the MapTvContextMenu
        return tvs?.sort(SortUtils.MONITORED_TV_ALPHABETICAL_SORTING).map(monitoredTv => {
            const tvId = monitoredTv.refLocation.id;
            const tvMeasures = this.props.monitoredMeasures?.filter(
                monitoredMeasure => tvId === MeasureUtils.getTvLocation(monitoredMeasure.measure).id,
            );
            const occupancyPeriods = this.props.selectedFlightsOccupancyPeriods?.[tvId];
            const tvEvents = this.props.events?.filter(e => this.eventHasTv(e, monitoredTv));
            return {
                key: tvId,
                tvName: tvId,
                vsName: this.props.tvSetMap[tvId],
                refLoc: monitoredTv.tvRefLocation,
                events: tvEvents,
                elementary: monitoredTv.elementary,
                entryLoad: monitoredTv.loadValues,
                occupancyLoad: monitoredTv.occupancyLoadValues,
                monitoredMeasures: tvMeasures,
                activePeriods: monitoredTv.activePeriods,
                showLoadInactivePeriods: false,
                occupancyPeriods: occupancyPeriods,
                currentTime: this.props.currentTime,
                monitorable: monitoredTv.monitorable,
                selected: this.props.selectedTvs?.indexOf(monitoredTv) >= 0,
                displayOccupancy: 'all',
                displayOccupancyForTv: 'all',
                tvMeteoAlerts: this.props.meteoAlerts?.[tvId],
                hideTvName: true,
                hideVsName: true,
                hideSelectIcon: true,
                hideMoreMenu: true,
            };
        });
    });

    private eventHasTv(e: MonitoredEvent, monitoredTv: ExtendedMonitoredTv) {
        return (
            (MonitoredEventUtils.isWeatherEvent(e) &&
                e.refLocs?.some(refLoc => Utils.isShallowEquals(refLoc, monitoredTv.tvRefLocation))) ||
            (MonitoredEventUtils.isNoteEvent(e) && e.tvs?.includes(monitoredTv.refLocation.id))
        );
    }

    private renderMilitaryZonesContextMenuOptions(zones: Array<MilitaryZoneDto>, group: boolean) {
        return <MapMilitaryZoneContextMenu group={group} militaryZones={zones} />;
    }

    private renderSolutionTvImpactMapContextMenuOptions(
        impacts: SolutionTvImpact[],
        workspaceTvs: Array<ExtendedMonitoredTv>,
        group: boolean,
    ) {
        return (
            <MapTVImpactContextMenu
                group={group}
                tvImpacts={impacts}
                onClose={this.props.onClose}
                workspaceTvIds={workspaceTvs?.map(emt => emt.refLocation.id)}
                tvSetMap={this.props.tvSetMap}
            />
        );
    }

    private renderSolutionMeasureImpactMapContextMenuOptions(
        measures: NiaMeasureImpact[],
        workspaceMeasures: Array<MonitoredMeasure>,
        group: boolean,
    ) {
        return (
            <MapMeasureImpactContextMenu
                measures={measures}
                workspaceMeasureIds={workspaceMeasures?.map(mm => mm.measure?.measureId?.id)}
                onClose={this.props.onClose}
                group={group}
            />
        );
    }

    private static itExists(value: Array<any>): number {
        if (Utils.isExists(value) && value.length > 0) return 1;
        return 0;
    }
}
